var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyInbox = function SvgEmptyInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8FC",
    fillRule: "evenodd",
    d: "M48.119 73.307A12.095 12.095 0 0 0 48 75c0 6.627 5.373 12 12 12s12-5.373 12-12c0-.575-.04-1.14-.118-1.693H101V100a3 3 0 0 1-3 3H22a3 3 0 0 1-3-3V73.307h29.119Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8FC",
    fillRule: "evenodd",
    d: "M73 74c0 7.18-5.82 13-13 13s-13-5.82-13-13c0-.233.006-.464.018-.693H19l9.56-28.268A3 3 0 0 1 31.402 43h57.196a3 3 0 0 1 2.842 2.039L101 73.307H72.982c.012.23.018.46.018.693Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6E5F2",
    fillRule: "evenodd",
    d: "M71.82 75.286c0 5.507-5.124 12.464-11.445 12.464C54.055 87.75 48 81.632 48 76.125V74.25H27.375l8.417-20.186c.363-.935 1.369-1.564 2.502-1.564h44.163c1.133 0 2.14.63 2.502 1.564l8.416 20.186H71.82c.01.176 0 .857 0 1.036Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D6E5F2",
    strokeWidth: 2.5,
    d: "M20.25 73.512V100c0 .967.784 1.75 1.75 1.75h76a1.75 1.75 0 0 0 1.75-1.75V73.512L90.255 45.44a1.75 1.75 0 0 0-1.657-1.189H31.402a1.75 1.75 0 0 0-1.657 1.19L20.25 73.511Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D6E5F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M20.5 74h13m-.5 0h12.745c1.877 0 1.877 1.319 1.877 2 0 6.627 5.496 12 12.276 12 6.78 0 12.276-5.373 12.276-12 0-.681 0-2 1.876-2H99M85.1 20.303 74 32.756M59.1 16v16.756V16ZM33 20.303l11.1 12.453L33 20.303Z"
  })));
};
export default SvgEmptyInbox;